export default __webpack_public_path__ + "static/media/maria-ayala.87d30ab9.jpg";